<template>
  <header id="header" style="padding: 0 15px">
    <div
      id="navbar-offcanvas"
      class="d-flex align-items-center justify-content-center"
    >
      <img
        :src="require('@/assets/images/svg/ícone-menu-lateral.svg')"
        alt=""
        data-bs-toggle="offcanvas"
        data-bs-target="#menu"
        aria-controls="menu"
        style="cursor: pointer"
      />
      <Logo v-if="!isClickMenu" :stylizationLogo="'stylizationLogo'" />
    </div>

    <div class="header-part-right d-flex">
      <Stores v-if="!isMobile" />

      <!-- Notificaiton -->
      <div
        class="dropdown d-flex justify-content-center align-items-center"
        style="width: -webkit-fill-available; margin-left: 30px"
      >
        <span
          class="position-relative"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          <p
            v-if="qtdNotification > 0"
            style="
              position: absolute;
              background: #132177;
              border-radius: 100%;
              width: 16px;
              height: 16px;
              font-size: 10px;
              text-align: center;
              color: #fff;
              font-weight: 600;
              top: -3px;
              right: -10px;
            "
          >
            {{ qtdNotification }}
          </p>
          <b-icon icon="bell" style="color: var(--blue-dark)"></b-icon>
        </span>
        <!-- <ul class="dropdown-menu border-0">
          <li><a class="dropdown-item" href="#">Action</a></li>
          <li><a class="dropdown-item" href="#">Another action</a></li>
          <li><a class="dropdown-item" href="#">Something else here</a></li>
        </ul> -->
      </div>

      <!-- User avatar dropdown -->

      <section
        style="
          width: 100%;
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-left: 32px;
        "
      >
        <img
          class="isResponsive"
          :class="!openProfileMenu ? 'showProfileMenu' : 'hideProfileMenu'"
          :src="require('@/assets/images/svg/avatar.svg')"
          alt=""
          style="margin: 8px"
        />
        <div
          style="
            width: 100%;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            align-items: center;
          "
        >
          <p
            :class="!openProfileMenu ? 'showProfileMenu' : 'hideProfileMenu'"
            style="
              font-style: normal;
              font-weight: 500;
              font-size: 16px;
              color: var(--blue-dark);
              margin: 0;
              width: max-content;
            "
          >
            Olá, {{ nome }}
          </p>
          <div
            class="dropdown"
            :class="openProfileMenu ? 'showProfileMenu' : 'hideProfileMenu'"
          >
            <span
              style="width: max-content"
              :class="!openProfileMenu ? 'showProfileMenu' : 'hideProfileMenu'"
              @click="clickProfileMenu(true)"
              class="d-flex justify-content-center align-items-center"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <p
                style="
                  font-style: normal;
                  font-weight: 300;
                  font-size: 12px;
                  color: var(--black-medium);
                  margin: 0;
                "
              >
                Minha conta
              </p>
              <img
                class="cursor-pointer"
                :src="require(`@/assets/images/svg/down arrow.svg`)"
                alt=""
                style="margin-left: 10px"
              />
            </span>
            <ul
              :class="openProfileMenu ? 'show' : ''"
              class="dropdown-menu border-0 pt-0"
              style="filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25))"
            >
              <li
                @click="clickProfileMenu(false)"
                class="d-flex justify-content-center align-items-center dropdown-item"
                :style="{
                  'background-image':
                    'url(' +
                    require(`@/assets/images/svg/background-menu-profile.svg`) +
                    ')',
                }"
                style="
                  height: 100px;
                  background-size: cover;
                  background-repeat: no-repeat;
                  width: 100%;
                  background-position: center;
                  border-top-left-radius: calc(0.375rem - 1px);
                  border-top-right-radius: calc(0.375rem - 1px);
                  margin-bottom: 0.5rem;
                "
              >
                <img :src="require('@/assets/images/svg/avatar.svg')" alt="" />
                <div
                  class="d-flex flex-column align-items-start"
                  style="padding-left: 8px"
                >
                  <p
                    style="
                      font-style: normal;
                      font-weight: 500;
                      font-size: 16px;
                      color: var(--white);
                      margin: 0;
                    "
                  >
                    Olá, {{ nome }}
                  </p>
                  <span
                    class="dropdown d-flex justify-content-center align-items-center"
                  >
                    <p
                      style="
                        font-style: normal;
                        font-weight: 300;
                        font-size: 12px;
                        color: var(--white);
                        margin: 0;
                      "
                    >
                      Minha conta
                    </p>
                    <img
                      class="cursor-pointer"
                      :src="
                        require(`@/assets/images/svg/ícone-seta-para-cima.svg`)
                      "
                      alt=""
                      style="margin-left: 10px"
                    />
                  </span>
                </div>
              </li>
              <li>
                <router-link class="dropdown-item" :to="{ name: 'Profile' }"
                  >Perfil</router-link
                >

                <!-- <button class="dropdown-item" type="button">Perfil</button> -->
              </li>
              <hr class="w-100" style="background-color: var(--blue-dark)" />
              <li>
                <!-- <router-link class="dropdown-item" :to="{ name: 'Profile' }"
                  >Perfil</router-link
                > -->
                <button type="button" class="dropdown-item" @click="logout">
                  Sair
                </button>
              </li>
            </ul>
          </div>
        </div>
      </section>
    </div>
    <div
      class="offcanvas offcanvas-start align-items-center"
      tabindex="-1"
      id="menu"
      aria-labelledby="menuLabel"
      style="max-width: 254px"
    >
      <div class="offcanvas-header" style="width: 80%">
        <img
          style="cursor: pointer"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
          :src="require('@/assets/images/svg/ícone-seta-esquerda-azul.svg')"
          alt=""
        />
        <Logo v-if="isClickMenu" />
        <!-- <button type="button" class="btn-close text-reset"></button> -->
      </div>
      <nav class="offcanvas-body" style="width: 80%">
        <Stores v-if="isMobile" />

        <div
          class="d-flex align-items-center justify-content-start w-100 option-menu"
        >
          <img
            :src="require('@/assets/images/svg/ícone-casa.svg')"
            alt=""
            class="icon-option-menu"
          />
          <router-link
            :to="{ name: 'Dashboard' }"
            style="
              font-style: normal;
              font-weight: 400;
              font-size: 16px;
              color: var(--black-medium);]
            "
            class="text-decoration-none"
            >Dashboard</router-link
          >
        </div>
        <div
          class="d-flex align-items-center justify-content-start w-100 option-menu"
        >
          <img
            :src="require('@/assets/images/svg/ícone-noticias.svg')"
            alt=""
            class="icon-option-menu"
          />
          <router-link
            :to="{ name: 'Posts' }"
            style="
              font-style: normal;
              font-weight: 400;
              font-size: 16px;
              color: var(--black-medium);
            "
            class="text-decoration-none"
          >
            Postagens
          </router-link>
        </div>
        <div
          class="d-flex align-items-center justify-content-start w-100 option-menu"
        >
          <img
            :src="require('@/assets/images/svg/ícone-calendario.svg')"
            alt=""
            class="icon-option-menu"
          />
          <router-link
            :to="{ name: 'Calendar' }"
            style="
              font-style: normal;
              font-weight: 400;
              font-size: 16px;
              color: var(--black-medium);]
            "
            class="text-decoration-none"
            >Calendário</router-link
          >
        </div>
        <div
          v-if="isAdm"
          style="border-top: 1px solid #e3e7ee; height: 1px; margin: 32px 0"
          class="w-100"
        ></div>
        <p
          v-if="isAdm"
          style="
            font-style: normal;
            font-weight: 500;
            font-size: 10px;
            color: var(--grey-medium);
            text-transform: uppercase;
            line-height: 158%;
          "
        >
          administração
        </p>
        <div
          v-if="isAdm"
          class="d-flex align-items-center justify-content-start w-100 option-menu"
        >
          <img
            :src="require('@/assets/images/svg/ícone-casa.svg')"
            alt=""
            class="icon-option-menu"
          />
          <router-link
            :to="{ name: 'Users' }"
            style="
              font-style: normal;
              font-weight: 400;
              font-size: 16px;
              color: var(--black-medium);]
            "
            class="text-decoration-none"
            >Usuários</router-link
          >
        </div>
        <div
          v-if="isAdm"
          class="d-flex align-items-center justify-content-start w-100 option-menu"
        >
          <img
            :src="require('@/assets/images/svg/lojas.svg')"
            alt="Lojas"
            class="icon-option-menu store"
          />
          <router-link
            :to="{ name: 'Stores' }"
            style="
              font-style: normal;
              font-weight: 400;
              font-size: 16px;
              color: var(--black-medium);]
            "
            class="text-decoration-none"
            >Lojas</router-link
          >
        </div>
        <div
          v-if="isAdm"
          class="d-flex align-items-center justify-content-start w-100 option-menu"
        >
          <img
            :src="require('@/assets/images/svg/ícone-biblioteca.svg')"
            alt=""
            class="icon-option-menu"
          />
          <router-link
            :to="{ name: 'library' }"
            style="
              font-style: normal;
              font-weight: 400;
              font-size: 16px;
              color: var(--black-medium);]
            "
            class="text-decoration-none"
            >Biblioteca</router-link
          >
        </div>
      </nav>
    </div>
  </header>
</template>
<script>
// import VuePerfectScrollbar from "vue-perfect-scrollbar";
import Logo from "@/components/Logo.vue";
import Stores from "@/components/Stores.vue";
import { mapActions } from "vuex";

export default {
  name: "Header",
  components: { Logo, Stores },
  data() {
    return {
      nome: "",
      openProfileMenu: false,
      qtdNotification: 0,
      isClickMenu: false,
      isMobile: false,
      isAdm: false,
    };
  },
  created() {
    this.getUser();
  },
  mounted() {
    let _this = this;
    let offcanvas = document.getElementById("menu");

    if (window.matchMedia("(max-width: 680px)").matches) {
      _this.isMobile = true;
    } else {
      _this.isMobile = false;
    }

    offcanvas.addEventListener("hidden.bs.offcanvas", function () {
      _this.isClickMenu = false;
    });
    offcanvas.addEventListener("show.bs.offcanvas", function () {
      _this.isClickMenu = true;
    });
  },
  methods: {
    ...mapActions(["getUserByEmail"]),

    clickProfileMenu(bool) {
      this.openProfileMenu = bool;
    },
    logout() {
      localStorage.removeItem("email");
      localStorage.removeItem("token");
      this.$router.push({ name: "Login" });
    },
    getUser() {
      this.getUserByEmail().then((response) => {
        const data = response.data.data[0];

        this.firstName(data.name);

        data.roles.forEach((element) => {
          if (element == "Administrador") {
            this.isAdm = true;
          }
        });
      });
    },
    firstName(name) {
      if (name.substring(0, name.indexOf(" ")) == "") {
        this.nome = name;
      } else {
        let first = name.substring(0, name.indexOf(" "));
        this.nome = first;
      }
    },
  },
};
</script>
<style scoped>
#header {
  position: fixed;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 82px;
  background-color: var(--yellow);
  z-index: 1;
}
.hideProfileMenu {
  visibility: hidden;
}
.showProfileMenu {
  visibility: initial;
}
#menu {
  border-radius: 0px 16px 16px 0px;
}
.icon-option-menu {
  margin-right: 16.6px;
}

.icon-option-menu.store {
  margin-left: 3px;
  margin-right: 18px;
  width: 16px;
}
.option-menu {
  padding: 13px;
  cursor: pointer;
}
.option-menu:hover {
  background-color: var(--blue-light);
  border-radius: 4px;
}
.stylizationLogo {
  margin: 10px;
}

@media only screen and (max-width: 425px) {
  .isResponsive {
    display: none;
  }
}
@media only screen and (max-width: 350px) {
  div#navbar-offcanvas {
    flex-direction: column-reverse;
  }
  .stylizationLogo {
    margin: 0;
  }
}
</style>
